import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { selectAddressParamsMemoize } from '@r1-frontend/entities/ContactAddress/selectors/selectAddressParams';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult'; // TODO заменить на объединение строк
import { useResultPopup } from '@r1-frontend/ui-react/components/popups/useResultPopup';

import { PersonForm } from '~/src/features/full-buy/components/uiReactComponents/PersonForm';
import {
    isGigabitCanConnected,
    isGigaSpeedRequired,
    isTariffCanConnected,
    submitRequest,
} from '~/src/features/full-buy/functions';
import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TState } from '~/src/store';
import { selectCsrf } from '~/src/store/selectors/auth/selectCsrf';

import * as ST from './styled';

/**
 * Форма для отправки заявки на подключение
 */
const RequestForm = (): JSX.Element => {
    const csrf = useSelector(selectCsrf);
    const router = useRouter();
    const onClickClose = () => router.push('/');
    const [PopupResult, showResult] = useResultPopup(onClickClose);
    const [fio, setFio] = useState('');
    const [phone, setPhone] = useState('');

    const {
        tariffPackage,
        products,
        unifiedSelectedAddress,
        addressParams,
        isHouseConnected,
        gigabitAvail,
    } = useSelector((state: TState) => ({
        tariffPackage: selectCurrentTariff(state),
        products: state.fullBuy.products,
        unifiedSelectedAddress: state.fullBuy.selectedAddress,
        addressParams: selectAddressParamsMemoize(state),
        isHouseConnected: state.contactAddress.verifiedAddressData.isHouseConnected,
        gigabitAvail: state.contactAddress.verifiedAddressData.gigabitAvail,
    }));

    const { isMono, speed, sale_package_id, tariff_name, additionalProducts } = tariffPackage || {};

    const gigabitMayConnect = isGigabitCanConnected(gigabitAvail);
    const requiredGigaSpeed = isGigaSpeedRequired(speed || 0);
    const shouldConnect = isTariffCanConnected(isHouseConnected, requiredGigaSpeed, gigabitMayConnect);

    const onSubmitRequest = async() => {
        const resp = await submitRequest({
            isMono: !!isMono,
            fio,
            phone,
            csrf,
            sale_package_id,
            tariff_name,
            additionalProducts: additionalProducts || [],
            products: products || [],
            address: unifiedSelectedAddress?.address.value,
            street: addressParams?.street?.label,
            house: addressParams?.house?.label,
            flat: addressParams?.flat,
            shouldConnect,
        });

        const { ok, message } = resp;

        showResult({
            type: ok ? EResultPopupStatus.SUCCESS : EResultPopupStatus.ERROR,
            title: ok ? 'Заявка на подключение отправлена' : 'Произошла ошибка',
            text: ok ? 'Мы свяжемся с вами в ближайшее время' : message,
        });
    };

    return (
        <ST.EditableContactsForm>
            <ST.BlockWrap>
                <PersonForm
                    fio={fio}
                    phone={phone}
                    onChangeFio={setFio}
                    onChangePhone={setPhone}
                    isNeedToBlockInvalidFio
                    actionButtonProps={{
                        children: 'Позвоните мне',
                        onClick: onSubmitRequest,
                        disabled: !fio || !phone,
                    }}
                />
            </ST.BlockWrap>
            <PopupResult/>
        </ST.EditableContactsForm>
    );
};

export default memo(RequestForm);
